import src from "IMAGE";
export default { src, width: 125, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANklEQVR42g3Htw2AMAAAwa8swRSmoEHCUQ77T+Yvrjjoz+YOBZhqWtr69UGNiysk05VVNfQqHog/A81MXTz7AAAAAElFTkSuQmCC"};
